import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { CustomButton } from "@/components/Button";

interface AgentDetailLoadErrorProps {
  onRetry: () => void;
  onBack?: () => void;
}

export const AgentDetailLoadError: React.FC<AgentDetailLoadErrorProps> = ({ onRetry, onBack }) => (
  <Box p={3} textAlign="center" data-testid="agent-detail-load-error">
    <Typography role="alert">プランナー情報を取得できませんでした。もう一度お試しください。</Typography>
    <Box mt={2}>
      <CustomButton customVariant="filled" onClick={onRetry}>再試行する</CustomButton>
    </Box>
    {onBack && (
      <Box mt={2}>
        <CustomButton customVariant="outlinedPrimary" onClick={onBack}>プランナー一覧へ戻る</CustomButton>
      </Box>
    )}
  </Box>
);
